module.exports = __webpack_public_path__ + "img/ussd.164bf0d3.svg";